import { DateValue, DatesRangeValue } from '@mantine/dates';

/**
 * Default date format options
 */
const DEFAULT_DATE_FORMAT: Intl.DateTimeFormatOptions = {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    timeZone: 'UTC',
};

/**
 * Formats a single date for display
 */
export const formatDate = (
    date: DateValue,
    options: Intl.DateTimeFormatOptions = DEFAULT_DATE_FORMAT
): string => {
    if (!date) return '';
    const dateObj = date instanceof Date ? date : new Date(date);
    return dateObj.toLocaleDateString('en-US', options);
};

/**
 * Formats a date range for display
 */
export const formatDateRange = (dateRange: DatesRangeValue, options?: Intl.DateTimeFormatOptions): string => {
    if (!dateRange) return '';
    const [start, end] = dateRange;
    if (!start && !end) return '';

    const parts = dateRange.map(date => (date ? formatDate(date, options) : '')).filter(Boolean);

    return parts.join(' to ');
};

/**
 * Checks if a date value is empty/null
 */
export const isDateEmpty = (date: DateValue): boolean => {
    return date === null || date === undefined;
};

/**
 * Checks if a date range is empty (both dates are null)
 */
export const isDateRangeEmpty = (dateRange: DatesRangeValue): boolean => {
    if (!dateRange) return true;
    const [start, end] = dateRange;
    return isDateEmpty(start) && isDateEmpty(end);
};
